/** West Africa Time (UTC+1, no DST). V8 has no CLDR short name for it (renders "GMT+1"), so it is labelled explicitly. */
export const WAT_TIME_ZONE = 'Africa/Lagos';

/** Parses API ISO timestamps as UTC when the response omits an offset, preserving explicit offsets. */
export function parseUtcTimestamp(value: string | null): Date | null {
  if (!value) {
    return null;
  }

  const match = value.trim().match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,7})?)?)(Z|[+-]\d{2}:\d{2})?$/i);
  if (!match) {
    return null;
  }

  const timestamp = Date.parse(`${match[1]}${match[2] ?? 'Z'}`);
  return Number.isNaN(timestamp) ? null : new Date(timestamp);
}

/** Formats an instant in the viewer's time zone (or `timeZone`) as "yyyy-mm-dd hh:mm[:ss] ZONE". */
export function formatTimestamp(value: number, options: { seconds?: boolean; timeZone?: string } = {}): string {
  const isWat = options.timeZone === WAT_TIME_ZONE;
  const formatted = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: options.seconds ? '2-digit' : undefined,
    hourCycle: 'h23',
    timeZone: options.timeZone,
    timeZoneName: isWat ? undefined : 'short',
  }).format(value).replace(',', '');

  return isWat ? `${formatted} WAT` : formatted;
}

/** Returns the WAT calendar date ("yyyy-mm-dd") containing the given instant. */
export function toWatDateIso(value: Date | number): string {
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: WAT_TIME_ZONE,
  }).format(value);
}
